__turbopack_context__.v({
  "backgroundImage": "GameDropRow-module__02VQoq__backgroundImage",
  "backgroundVideo": "GameDropRow-module__02VQoq__backgroundVideo",
  "button": "GameDropRow-module__02VQoq__button",
  "content": "GameDropRow-module__02VQoq__content",
  "main": "GameDropRow-module__02VQoq__main",
  "pegiWrapper": "GameDropRow-module__02VQoq__pegiWrapper",
  "rowIcon": "GameDropRow-module__02VQoq__rowIcon",
});
